<template>
	<div>
		<MainTempComp
			ref="mainTempRef"
			:searchOption="data.searchOption"
			:handleSearch="handleSearch"
		>
			<template #header>
				<span style="padding-left: 10px"></span>
				<el-button type="primary" @click="handleSearch">查询</el-button>
				<el-button type="primary" @click="handleAddUser"
					>新增</el-button
				>
				<el-button type="primary" @click="handleEditRole"
					>角色</el-button
				>
			</template>
			<template #main>
				<tableComp :tableData="data.tableData"></tableComp>
			</template>
		</MainTempComp>
		<!-- 添加用户 -->
		<add-user ref="AddUserRef"></add-user>
		<modify-info ref="ModifyInfoRef"></modify-info>
	</div>
</template>

<script>
import { onMounted, provide, reactive, ref } from "vue";
import tableComp from "./table.vue";
import AddUser from "./children/add-user.vue";
import { apiSysuserList } from "@/api/requestApis.js";
import ModifyInfo from "./children/modify-info.vue";
export default {
	name: "systemSettings",
	components: {
		tableComp,
		ModifyInfo,
		AddUser,
	},
	setup() {
		const mainTempRef = ref(null);
		const AddUserRef = ref(null);
		const ModifyInfoRef = ref(null);

		const data = reactive({
			tableData: [],
			searchOption: [
				{
					name: "姓名",
					type: "input",
					key: "chineseName",
					value: "",
				},
				{
					name: "手机号",
					type: "input",
					key: "phone",
					value: "",
				},
				{
					name: "创建时间",
					type: "datePicker",
					key: "time",
					value: "",
					paramsKey: {
						start_time: "startTime",
						end_time: "endTime",
					},
				},
			],
		});
		const handleSearch = async () => {
			const res = await apiSysuserList({
				size: mainTempRef.value.pageSize,
				current: mainTempRef.value.currentPage,
				...mainTempRef.value.searchParams,
			});
			mainTempRef.value.setTotalValue(res.total || 0);
			data.tableData = res.list || [];
		};
		const handleAddUser = () => {
			AddUserRef.value.handleToggle(true);
		};

		const handleUpdateTable = () => {
			mainTempRef.value.setPageValue(1);
			handleSearch();
		};
		const handleEditRole = () => {
			ModifyInfoRef.value.handleToggle(true);
		};
		provide("handleUpdateTable", handleUpdateTable);
		provide("handleSearch", handleSearch);
		onMounted(() => {
			handleSearch();
		});
		return {
			ModifyInfoRef,
			handleEditRole,
			handleAddUser,
			AddUserRef,
			mainTempRef,
			data,
			handleSearch,
		};
	},
};
</script>

<style scoped>
</style>
